import axios from 'axios';

export default axios.create({
    baseURL: window.$domain,

    auth: {
        /*username: process.env.MIX_AUTH_USERNAME,
        password: process.env.MIX_AUTH_PASSWORD*/
        username: 'sosial',
        password: 'puu7tmk7mo28dompcd5b'
    },
    headers: {'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-TOKEN': window.csrf_token}
});
